import ModalViewModel from 'infra/ModalViewModel'
import { BulkActionError, BulkActionJob } from 'jobs/bulk-actions'

import { action, computed, makeObservable, observable } from 'mobx'

export interface ActionError {
  jobId: string
  jobTitle: string
  error: string
}

export default class BulkActionJobErrorViewModel extends ModalViewModel {
  @observable errors: ActionError[] = []

  constructor() {
    super()
    makeObservable(this)
  }

  @computed
  get hasErrors() {
    return this.errors.length > 0
  }

  /**
   * Shows the errors, resolving each job's short id and title from the jobs the action ran on.
   */
  @action.bound
  showErrors(errors: BulkActionError[], jobs: BulkActionJob[]) {
    this.errors = errors.map((error) => {
      const job = jobs.find((j) => j.id === error.jobId)
      return {
        error: error.error,
        jobId: job?.shortId || '',
        jobTitle: job?.displayName || '',
      }
    })
    super.show()
  }
}
